var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlotteStudiotelAts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.c{fill:#fff;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21,
    height: 21
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.3 6.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.128,401.024H45.009a1.682,1.682,0,0,0,1.681-1.682v-.008l.009-4.675a1.69,1.69,0,0,0-1.69-1.69H30.128a1.694,1.694,0,0,0-1.69,1.69v4.675A1.7,1.7,0,0,0,30.128,401.024Zm0-5.52a.845.845,0,0,1,.845-.845H44.164a.845.845,0,0,1,.845.845v2.759H30.128Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    transform: "translate(9.735 2.837)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    transform: "translate(11.747 2.837)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    transform: "translate(13.723 2.837)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21,
    height: 21
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.3 6.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.128,401.024H45.009a1.682,1.682,0,0,0,1.681-1.682v-.008l.009-4.675a1.69,1.69,0,0,0-1.69-1.69H30.128a1.694,1.694,0,0,0-1.69,1.69v4.675A1.7,1.7,0,0,0,30.128,401.024Zm0-5.52a.845.845,0,0,1,.845-.845H44.164a.845.845,0,0,1,.845.845v2.759H30.128Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    transform: "translate(9.735 2.837)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    transform: "translate(11.747 2.837)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    transform: "translate(13.723 2.837)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21,
    height: 21
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.3 6.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.128,401.024H45.009a1.682,1.682,0,0,0,1.681-1.682v-.008l.009-4.675a1.69,1.69,0,0,0-1.69-1.69H30.128a1.694,1.694,0,0,0-1.69,1.69v4.675A1.7,1.7,0,0,0,30.128,401.024Zm0-5.52a.845.845,0,0,1,.845-.845H44.164a.845.845,0,0,1,.845.845v2.759H30.128Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    transform: "translate(9.735 2.837)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    transform: "translate(11.747 2.837)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    transform: "translate(13.723 2.837)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlotteStudiotelAts);
export default __webpack_public_path__ + "static/media/flotte_studiotel_ATS.ca88b474f6193ea413a62869d7a1375d.svg";
export { ForwardRef as ReactComponent };